import { useAuthStore } from '@/store/useAuthStore'
import type { User } from '@/types/User'

/**
 * Synchronous session access layer over the Zustand auth store.
 * Use this for non-React contexts (e.g. ApiClient interceptors).
 * React components should prefer `useAuthStore` directly.
 */
class Session {
  private static instance: Session

  private constructor() {}

  public static getInstance(): Session {
    if (!Session.instance) {
      Session.instance = new Session()
    }
    return Session.instance
  }

  public getToken(): string | null {
    return useAuthStore.getState().accessToken
  }

  public getUser(): User | null {
    return useAuthStore.getState().user
  }

  public getLanguage(): string {
    return useAuthStore.getState().language
  }

  public setLanguage(language: string): void {
    useAuthStore.getState().setLanguage(language)
  }

  public getTimezone(): string {
    return useAuthStore.getState().timezone
  }

  public setTimezone(timezone: string): void {
    useAuthStore.getState().setTimezone(timezone)
  }

  public setAuth(token: string, user: User): void {
    useAuthStore.getState().setAuth(token, user)
  }

  public remove(): void {
    useAuthStore.getState().logout()
  }

  public isValid(): boolean {
    return useAuthStore.getState().isAuthenticated()
  }

  public getBaseURL(): string {
    return useAuthStore.getState().getBaseURL()
  }
}

export default Session.getInstance()
